export const EnvironmentEnum = Object.freeze({
    local: "local",
    dev: "dev",
    test: "test",
    vimap: "vimap",
    ngm: "ngm",
    viettel: "viettel"
});
